import React from "react"
import PropTypes from "prop-types"
import { createGlobalStyle } from "styled-components"

import * as S from "./styled"

import Theme from "../../styles/theme"
import ResetCSS from "../../styles/resetCSS"
import BaseCSS from "../../styles/baseCSS"
import Navbar from "../Navbar/"
import Footer from "../Footer/"

const GlobalStyles = createGlobalStyle`
  ${ResetCSS}
  ${BaseCSS}
`

const Layout = ({ children }) => {
  return (
    <Theme>
      <S.LayoutWrapper>
        <GlobalStyles />
        <Navbar />

        <S.LayoutMain>{children}</S.LayoutMain>

        <Footer />
      </S.LayoutWrapper>
    </Theme>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
